module.exports = __webpack_public_path__ + "static/IMG_0052-bba4851eaed8d81f350af7240f35ea3e.jpg";